"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _StoreComponent2 = _interopRequireDefault(require("../store/StoreComponent"));

var _Validations = require("../../validations/Validations");

var _GenericStore = require("../store/GenericStore");

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid/Grid"));

var _reactI18next = require("react-i18next");

var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));

var startOfDay = _interopRequireWildcard(require("date-fns"));

var _pickers = require("@material-ui/pickers");

var _styles = require("@material-ui/core/styles");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  Input: {
    width: '90%'
  }
};

var _Date = /*#__PURE__*/function (_StoreComponent) {
  (0, _inherits2["default"])(Date, _StoreComponent);

  var _super = _createSuper(Date);

  function Date(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Date);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (date) {
      var _this$props = _this.props,
          parentPath = _this$props.parentPath,
          block = _this$props.block;
      var dict = {};
      dict[parentPath + '/value'] = date;
      dict[parentPath + '/isEdited'] = true;
      dict[parentPath + '/isDirty'] = _this.getForPath(parentPath + '/initial', '') !== date;

      _GenericStore.dataStore.setValues(dict); // validateField(parentPath, dataStore, block)

    });
    var _parentPath = _this.props.parentPath;

    _this.addStoresAndPathes([{
      store: _GenericStore.dataStore,
      pathes: [_parentPath]
    }]);

    var _dict = {};
    _dict[_parentPath + '/isValid'] = true;

    _GenericStore.dataStore.setValues(_dict);

    return _this;
  }

  (0, _createClass2["default"])(Date, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          parentPath = _this$props2.parentPath,
          block = _this$props2.block,
          t = _this$props2.t,
          classes = _this$props2.classes;
      var value = this.getForPath(parentPath + '/value', '01-01-1970');
      var isValid = this.getForPath(parentPath + '/isValid', true);
      var errorMessage = this.getForPath(parentPath + '/errorMessage', '');
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.Input
      }, /*#__PURE__*/_react["default"].createElement(_pickers.MuiPickersUtilsProvider, {
        utils: _dateFns["default"]
      }, /*#__PURE__*/_react["default"].createElement(_pickers.KeyboardDatePicker, {
        id: this._id,
        name: this._id,
        fullWidth: true,
        label: t(block.label),
        format: 'MM/dd/yyyy',
        inputVariant: 'outlined',
        value: value,
        onChange: this.onChange,
        helperText: !isValid && t(errorMessage),
        error: !isValid
      })));
    }
  }]);
  return Date;
}(_StoreComponent2["default"]);

_TextField["default"].propTypes = {};

var _default = (0, _styles.withStyles)(styles)((0, _reactI18next.withTranslation)('common')(_Date));

exports["default"] = _default;